import React from "react";
import { useModal } from "../../hooks/useModal";
import Button from "../form/Button";
import { withErrorBoundary } from "../components/withErrorBoundary";

interface ModalProps {
	type: "cancel" | "confirm" | "error";
}

const Modal: React.FC<ModalProps> = ({ type }) => {
	const { modalTitle, modalMessage, hideModal, onConfirm, onCancel } =
		useModal();

	const handleConfirm = () => {
		hideModal(type);
		onConfirm?.();
	};

	const handleCancel = () => {
		hideModal(type);
		onCancel?.();
	};

	return (
		<div className="z-10 p-4 w-full h-full absolute top-0 left-0 flex flex-col justify-center items-center bg-slate-900/70 text-white text-sm font-normal font-['Inter'] text-xl gap-2">
			<div className="p-4 text-center relative bg-white rounded-[5px] shadow-lg">
				<div className="text-lg mb-4 text-black font-normal">{modalTitle}</div>
				<div className="text-sm mb-6 text-gray-600">{modalMessage}</div>
				<div className="flex gap-2 justify-center">
					{type === "cancel" && (
						<>
							<Button
								className="flex-1 max-w-[140px]"
								onClick={handleConfirm}
								type="primary"
							>
								Yes
							</Button>
							<Button
								className="flex-1 max-w-[140px]"
								onClick={handleCancel}
								type="primary"
								subType="outline"
							>
								No
							</Button>
						</>
					)}
					{type === "confirm" && (
						<>
							<Button onClick={handleConfirm} type="primary">
								Confirm
							</Button>
							<Button onClick={handleCancel} type="primary" subType="outline">
								Cancel
							</Button>
						</>
					)}
					{type === "error" && (
						<Button onClick={handleCancel} type="primary">
							Close
						</Button>
					)}
				</div>
			</div>
		</div>
	);
};

export default withErrorBoundary(Modal);
